import React from 'react';
import styled from 'styled-components';
import { Card } from 'antd';
import PageTitle from '../components/layout/PageTitle';
import { PageContent, SideBar } from '../components/layout/style';
import SuggestionBlock from '../components/layout/SuggestionBlock';
import VkLink from '../components/layout/VkLink';

const { Meta } = Card;

const masters = [
    {
        name: 'МаГИ',
        logo: '/images/gusli.pro.jpg',
        description: 'Мастерская гусельного искусства, а также школа игры',
        site: 'http://www.gusli.pro',
        cover: function renderMagiCover(item) {
            return <div style={{ background: '#fffbe5', maxHeight: '300px', textAlign: 'center' }}>
                <img alt={item.name} style={{ maxHeight: '300px' }} src={item.logo}/>
            </div>
        }
    },
    {
        name: 'Мир гуслей',
        logo: '/images/gor.jpg',
        siteUrl: 'https://mirgusley.com?partnerid=1114',
        site: 'https://mirgusley.com',
        description: 'Активно развивающаяся мастерская. Практически, фабрика. Приемлемые цены.'
    },
    {
        name: 'Мастер Василий Фоменко',
        logo: '/images/kol.jpg',
        site: 'http://www.psaltery.ru',
        vk: 'https://vk.com/psaltery_ru',
        description: 'Не знаю, удастся что-нибудь купить здесь, но обязательно зайдите на сайт и посмотрите на эту красоту.'
    },
    {
        name: 'Гусельник',
        logo: '/images/guselnik.png',
        description: 'Мастерская. Приличный (привычный) интернет-магазин',
        site: 'https://guselnik.ru'
    },
];

const MastersList = styled.ul`
    margin: 0;
    padding: 0;
`;

const MasterTitle = styled.a`
    font-size: 16px;
    color: #aa0000;
    font-family: 'Ruslan Display', cursive;
`;

const MasterDescription = styled.div`
    font-size: 16px;
    color: black;
`;

const MasterLinks = styled.div`
    padding-top: 16px;
`;

const MasterLink = styled.div`
    font-size: 16px;
    color: black;
`;

export default function Masters() {
    return <>
        <PageContent>
            <PageTitle title='Мастерские'/>
            <p>
                Где купить гусли? Вариантов (я надеюсь) много. А пока список такой:
            </p>

            <MastersList>
                {masters.map((item, index) => (
                    <Card
                        key={`master-card-${index}`}
                        className='master-card'
                        cover={item.cover ? item.cover(item) : <img alt={item.name} style={{ maxWidth: '370px', maxHeight: '300px' }} src={item.logo}/>}
                    >
                        <Meta
                            title={<MasterTitle href={(item.siteUrl ? item.siteUrl : item.site) || item.vk} target='_blank' rel='noopener noreferrer'>{item.name}</MasterTitle>}
                            description={<MasterDescription>
                                {item.description}

                                <MasterLinks>
                                    {item.site && <MasterLink>
                                        Сайт: <a href={item.siteUrl ? item.siteUrl : item.site} target='_blank' rel='noopener noreferrer'>{item.site}</a><br/>
                                    </MasterLink>}
                                    {item.vk &&
                                    <MasterLink>
                                        <VkLink href={item.vk}/>
                                    </MasterLink>}
                                </MasterLinks>
                            </MasterDescription>}/>
                    </Card>
                ))}
            </MastersList>
        </PageContent>
        <SideBar>
            <SuggestionBlock title={'Выбор - дело добровольное'}>
                Если вы - мастер или представляете мастерскую, напишите нам - с удовольствием разместим ваши контакты
            </SuggestionBlock>
        </SideBar>
    </>
}

Masters.displayName = 'Masters';

